// What a league's state is called, and how it is set.
//
// The chips read SETUP / DRAFTING / ACTIVE / COMPLETED — schema words, in a
// product whose whole voice is deadpan institutional. A record book does not
// say a league is "active"; it says it is in season. Three pages each carried
// their own copy of the colour table, so the vocabulary lives here with it.
//
// Gold is spent on exactly one state: a draft in progress is the only moment
// the app is genuinely asking for you right now.

export interface StatusStyle {
  /** What the chip says. */
  label: string;
  /** Tailwind classes for the chip. */
  className: string;
}

const STATUSES: Record<string, StatusStyle> = {
  setup: { label: 'Taking Members', className: 'bg-secondary-100 text-secondary-600' },
  drafting: { label: 'On the Clock', className: 'bg-ink-900 text-gold' },
  // Legacy rows still carry 'draft'; it means the same thing and must not fall
  // through to the grey default, which is the dullest chip for the most urgent
  // state in the product.
  draft: { label: 'On the Clock', className: 'bg-ink-900 text-gold' },
  active: { label: 'In Season', className: 'bg-success-100 text-success-800' },
  playoffs: { label: 'Postseason', className: 'bg-gold text-ink-900' },
  completed: { label: 'Final', className: 'border border-secondary-300 text-secondary-500' },
  archived: { label: 'Archived', className: 'border border-secondary-300 text-secondary-500' },
};

export function statusStyle(status?: string | null): StatusStyle {
  return STATUSES[(status || '').toLowerCase()] || {
    // An unknown state says what it is rather than lying about it.
    label: status || 'Unknown',
    className: 'bg-secondary-100 text-secondary-600',
  };
}

export function statusLabel(status?: string | null): string {
  return statusStyle(status).label;
}
